import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "framework_project";

const keys = addTranslations(RESOURCE_NAME, {
    breadcrumb_frameworks: {
        en: "Frameworks",
        fr: "Référentiels",
    },
});
export function useFrameworkProjectTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
